import { useForm } from "react-hook-form";
import { useUploadBodyMapEntryMediaMutation } from "../../../services/api/bodyMapApi";
import { isDocumentPickerAsset, ThrelsFileType } from "ui/types/ThrelsFileType";
import { convertToFile } from "ui/utils/fileUtils";
import { useDisplayToast } from "ui/hooks/useDisplayToast";

export function useUploadBodyMapEntryMedia() {
  const { control, reset } = useForm({
    defaultValues: {
      image: [],
    },
  });

  const [uploadBodyMapEntryMedia, { isLoading }] =
    useUploadBodyMapEntryMediaMutation();

  const { showErrorToast } = useDisplayToast();

  const submit = async ({
    residentId,
    entryId,
    initialComment,
    image,
  }: {
    residentId: number;
    entryId: number;
    initialComment: string;
    image: ThrelsFileType;
  }) => {
    const formData = new FormData();
    formData.append("comment", initialComment);

    let files: File[] = [];
    if (isDocumentPickerAsset(image)) {
      files = convertToFile([image]);
    }
    if (files.length === 0) return;

    formData.append("image", files[0]!);

    try {
      await uploadBodyMapEntryMedia({
        residentId,
        entryId,
        formData,
      }).unwrap();
      reset();
    } catch (error) {
      showErrorToast(error);
    }
  };

  return { control, submit, isLoading };
}
